/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//Danish (Denmark)
export default {
  'company-hub.section-extension.config-panel.background-color-field.background-color': 'Baggrundsfarve',
  'company-hub.section-extension.config-panel.content-width-field.full-label': 'Komplet',
  'company-hub.section-extension.config-panel.content-width-field.full-tooltip': 'Fuld bredde',
  'company-hub.section-extension.config-panel.content-width-field.label': 'Indholdets bredde',
  'company-hub.section-extension.config-panel.content-width-field.narrow-label': 'Smalt',
  'company-hub.section-extension.config-panel.content-width-field.narrow-tooltip': 'Smalt',
  'company-hub.section-extension.config-panel.content-width-field.wide-label': 'Bredt',
  'company-hub.section-extension.config-panel.content-width-field.wide-tooltip': 'Bredt',
  'company-hub.section-extension.config-panel.preamble':
    'Organiser elementer i afsnit, der kan tilpasses. {supportLink}',
  'company-hub.section-extension.config-panel.preamble-link.label': 'Få mere at vide om design af din hub.',
  'company-hub.section-extension.config-panel.preamble-without-support-link':
    'Organiser relaterede elementer i afsnit med baggrunde og styling, der kan tilpasses.',
  'company-hub.section-extension.config-panel.title': 'Sektion',
  'company-hub.section-extension.error-loading-content': 'Fejl ved indlæsning af indhold',
  'company-hub.section-extension.manifest.content.header': 'Giv dit afsnit en titel',
  'company-hub.section-extension.manifest.content.placeholder-title': 'Pladsholder',
  'company-hub.section-extension.manifest.content.sub-header':
    'Organiser elementer i afsnit med baggrunde, der kan tilpasses.',
  'company-hub.section-extension.manifest.extension-lozenge-title': 'Sektion',
  'company-hub.section-extension.manifest.extension-title': 'Sektion [Ny]',
  'company-hub.section-extension.manifest.macro-description': 'Gruppér elementer sammen med en baggrund',
};
